import Vue from "vue";
import Vuex from "vuex";
import cards from "../data/cards";
import journeys from "../data/journeys";

Vue.use(Vuex);

// A lil' helper function
function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]
  }

  return [...array]
}

function randomBetween(min, max) {
  return Math.floor(Math.random() * max) + min;
}

export default new Vuex.Store({
  state: {
    API: "https://trains.trysmudford.com",
    // API: "http://trains-api.elf",
    pondering: [],
    gameId: null,
    player: 1,
    status: "waiting",
    syncedState: {
      gameState: "loading",
      playing: 1,
      players: [],
      journeys: [],
      cards: [],
      burnPile: []
    },
    journeys: [...journeys],
    totalTrains: 45,
    cardNames: [
      "Rainbow",
      "Black",
      "Blue",
      "Green",
      "Orange",
      "Pink",
      "Red",
      "White",
      "Yellow"
    ]
  },
  mutations: {
    setSyncedState(state, { res, player }) {
      Vue.set(state, "syncedState", res);
      state.player = Number(player);
    },

    pickJourneys(state, journeys) {
      const playerIndex = state.syncedState.players.findIndex(
        x => x.id === state.player
      );
      journeys.forEach(({ id, status = "in-progress" }) => {
        Vue.set(state.syncedState.players[playerIndex].journeys, id, status);
        state.pondering = state.pondering.filter(x => x !== id);
      });

      state.pondering.forEach(key => {
        state.syncedState.journeys.push(key);
      });

      state.pondering = [];
      state.status = "finishing";
    },

    ponderThreeJourneys(state) {
      state.status = "journeys";

      state.pondering = [
        state.syncedState.journeys.shift(),
        state.syncedState.journeys.shift(),
        state.syncedState.journeys.shift()
      ];
    },

    pickCard(state, colourIndex) {
      const playerIndex = state.syncedState.players.findIndex(
        x => x.id === state.player
      );
      state.syncedState.players[playerIndex].cards[colourIndex]++;
      state.status = "cards";
    },

    updateJourney(state, [id, status]) {
      const playerIndex = state.syncedState.players.findIndex(
        x => x.id === state.player
      );
      state.syncedState.players[playerIndex].journeys[id] = status;
    },

    layCard(state, colourIndex) {
      const playerIndex = state.syncedState.players.findIndex(
        x => x.id === state.player
      );
      state.syncedState.players[playerIndex].cards[colourIndex]--;
      state.syncedState.players[playerIndex].laid++;
      state.syncedState.burnPile.push(colourIndex);
    },

    laidCards(state, laid) {
      const playerIndex = state.syncedState.players.findIndex(
        x => x.id === state.player
      );
      state.syncedState.players[playerIndex].laidTally.push(laid);
    },

    toggleLongestTrain(state, id) {
      const playerIndex = state.syncedState.players.findIndex(x => x.id === id);

      Vue.set(
        state.syncedState.players[playerIndex],
        "longestTrain",
        !state.syncedState.players[playerIndex].longestTrain
      );
    },

    removeCard(state, stackIndex) {
      const nextTopCard = 5;
      state.syncedState.cards.splice(
        stackIndex,
        1,
        state.syncedState.cards[nextTopCard]
      );
      state.syncedState.cards.splice(nextTopCard, 1);
    },

    setStatus(state, status) {
      state.status = status;
    },

    nextGo(state) {
      state.syncedState.playing++;

      const player = state.syncedState.players.find(
        x => x.id === state.syncedState.playing
      );
      if (!player) state.syncedState.playing = state.syncedState.players[0].id;

      window.dispatchEvent(new Event("pushSync"));
    },

    topUpCards(state) {
      if (state.syncedState.cards.length < 10) {
        const shuffled = shuffle(state.syncedState.burnPile);
        state.syncedState.cards.push(...shuffled);
        state.syncedState.burnPile = [];
      }
    },

    addPlayers(state, playerNames) {
      const players = playerNames.map(({ name, colour }, index) => {
        return {
          id: index + 1,
          name,
          colour,
          laid: 0,
          laidTally: [],
          longestTrain: false,
          cards: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0 },
          journeys: {}
        };
      });

      Vue.set(state.syncedState, "players", players);
    },

    shuffleJourneys(state) {
      state.syncedState.journeys = shuffle(state.syncedState.journeys);
    },

    shuffleCards(state) {
      state.syncedState.cards = shuffle(state.syncedState.cards);
    },

    dealCards(state) {
      for (let index = 0; index < 4; index++) {
        state.syncedState.players.forEach(player => {
          const colour = state.syncedState.cards.shift();
          player.cards[colour]++;
        });
      }
    },

    changeGameState(state, status) {
      state.syncedState.gameState = status;
    },

    setGameId(state, gameId) {
      state.gameId = gameId;
    },

    startUp(state) {
      Vue.set(state.syncedState, "cards", shuffle([...cards]));
      Vue.set(
        state.syncedState,
        "journeys",
        shuffle([...journeys.map(x => x.id)])
      );
      Vue.set(state.syncedState, "burnPile", []);
      Vue.set(
        state.syncedState,
        "playing",
        randomBetween(1, state.syncedState.players.length)
      );
    }
  },
  actions: {
    fetch({ commit, state }, { game, player }) {
      return fetch(`${state.API}/game/${game}`)
        .then(x => x.json())
        .then(res => {
          commit("setSyncedState", { res, player });
          commit("setGameId", game);
        });
    },

    sync({ commit, state }) {
      return fetch(`${state.API}/game/${state.gameId}`)
        .then(x => x.json())
        .then(res => {
          commit("setSyncedState", { res, player: state.player });
        });
    },

    push({ state }) {
      const body = new FormData();
      body.append("body", JSON.stringify(state.syncedState));
      const request = new Request(`${state.API}/game/${state.gameId}`, {
        method: "POST",
        body,
        mode: "cors"
      });

      return fetch(request);
    },

    createGame({ state }) {
      const body = new FormData();
      body.append("body", JSON.stringify(state.syncedState));
      const request = new Request(`${state.API}/game/create`, {
        method: "POST",
        body,
        mode: "cors"
      });

      return fetch(request).then(x => x.json());
    },

    nextGo({ commit, dispatch }) {
      commit("topUpCards");
      commit("setStatus", "waiting");
      commit("nextGo");

      return dispatch("push");
    },

    endGame({ commit, dispatch }) {
      commit("changeGameState", "finished");
      return dispatch("push");
    },

    notFinished({ commit, dispatch }) {
      commit("changeGameState", "in-game");
      return dispatch("push");
    },

    startGame({ commit, dispatch }, players) {
      commit("addPlayers", players);
      commit("startUp");
      commit("dealCards");
      commit("changeGameState", "in-game");

      return dispatch("createGame")
        .then(({ gameId }) => {
          window.location.href = `/game/${gameId}`;
        })
        .catch(e => {
          console.log("fail", e);
        });
    },

    newGameFromCurrent({ commit, dispatch, state }) {
      commit("addPlayers", state.syncedState.players);
      commit("startUp");
      commit("dealCards");
      commit("changeGameState", "in-game");

      return dispatch("createGame")
        .then(({ gameId }) => {
          window.dispatchEvent(
            new CustomEvent("new-game", {
              detail: { newGameId: gameId, oldGameId: state.gameId }
            })
          );
        })
        .catch(e => {
          console.log("fail", e);
        });
    }
  },

  getters: {
    you(state) {
      return state.syncedState.players.find(x => x.id === state.player);
    },

    currentPlayer(state) {
      return state.syncedState.players.find(
        x => x.id === state.syncedState.playing
      );
    },

    game(state) {
      return {
        state
      };
    },

    scores(state) {
      let count = 0;
      const mostCompletedJourneys = state.syncedState.players.reduce(
        (players, player) => {
          const playerCount = Object.keys(player.journeys).filter(
            id => player.journeys[id] === "completed"
          ).length;

          if (count === playerCount) {
            players.push(player.id);
          } else if (count < playerCount) {
            players = [player.id];
            count = playerCount;
          }

          return players;
        },
        []
      );

      const scores = state.syncedState.players.map(player => {
        const trainScore = player.laidTally.reduce((current, cards) => {
          return current + [0, 1, 2, 4, 7, 10, 15][cards];
        }, 0);

        let journeyScore = 0;
        let completed = 0;
        Object.keys(player.journeys).map(id => {
          if (player.journeys[id] === "completed") {
            completed++;
            journeyScore += state.journeys.find(x => x.id == id).score;
          } else if (player.journeys[id] === "forfeited") {
            journeyScore -= state.journeys.find(x => x.id == id).score;
          }
        });

        const journeyBonus = mostCompletedJourneys.includes(player.id) ? 15 : 0;
        const trainBonus = player.longestTrain ? 10 : 0;

        return {
          trainScore,
          journeyScore,
          journeyBonus,
          trainBonus,
          completed,
          winner: false,
          name: player.name,
          colour: player.colour,
          id: player.id,
          total: trainScore + journeyScore + journeyBonus + trainBonus
        };
      });

      scores.sort((a, b) => b.total - a.total);

      scores.forEach(score => {
        score.winner = score.total === scores[0].total;
      });

      console.log(scores);

      const winners = scores
        .filter(x => x.total === scores[0].total)
        .map(x => x.name);

      return { scores, winners };
    },

    ponderingJourneys(state) {
      return state.pondering
        .map(x => state.journeys.find(y => y.id === x))
        .filter(Boolean);
    },

    yourGo(state) {
      return state.player === state.syncedState.playing;
    },

    cardStack(state) {
      return state.syncedState.cards.slice(0, 5).map(id => {
        return {
          colour: state.cardNames[id],
          id: id
        };
      });
    },

    topStack(state) {
      return state.syncedState.cards.slice(5, 7).map(id => {
        return {
          colour: state.cardNames[id],
          id: id
        };
      });
    },

    ableToPickUp(state, getters) {
      if (!getters.you) return null;
      return !Object.values(getters.you.journeys).find(
        x => x === "in-progress"
      );
    }
  }
});
